import React from "react";
import PropTypes from "prop-types";
import "./SidebarComponent.scss";
import { useGlobalContext } from "../../context";
import { Link, useLocation } from "react-router-dom";

const SidebarComponent = React.memo(function SidebarComponent({ href, icon }) {
  const { setActiveCard, activeCard, setShowContent, start, setStart } =
    useGlobalContext();

  const { pathname } = useLocation();
  const cardActive = pathname.slice(1);

  return (
    <li
      className={`side-nav__item ${
        cardActive === href ? "side-nav__item--active" : ""
      }`}
      onClick={() => {
        setActiveCard(href);
        if (activeCard === href || cardActive === href) {
          return;
        } else setShowContent(false);
        if (start) setStart(false);
      }}
    >
      <Link to={href} className="side-nav__link">
        {icon}
      </Link>
    </li>
  );
});

SidebarComponent.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default SidebarComponent;
